// apiClient.js
import axios from 'axios';
import { 
  getTokenReview,
  getTokenRenew,
  getErrAlertOpen,
  getErrAlertText,
  getLogoutHandler
} from '../store/tokenStore';
import Cookies from 'js-cookie'

// remove subdomain from url

const removeSubdomain = (url) => {

  const parts = url.split('.')
  parts.shift();
  // Join the rest back with dots
  console.log('xxx > ', parts.join('.'))
  return parts.join('.');

}

let baseUrl;
const hostname = window.location.hostname;


if(hostname.includes('localhost')){
  //baseUrl = `https://gateway.invoicebot.ai/company`;
  baseUrl = `https://gateway.docupathdev.app/company`;
}
else{
  baseUrl = `https://gateway.${removeSubdomain(window.location.hostname)}/${window.location.hostname.split('.').at(0)}`;
}

const axiosClient = axios.create({
  baseURL: baseUrl
});


axiosClient.interceptors.request.use(
  async (config) => {
    // Before sending the request, ensure the token is valid by calling tokenReview
    const tokenReview = getTokenReview();
    const isTokenValid = tokenReview ? await tokenReview() : false;
    console.log('Token 1');
    if (isTokenValid) {
      const token = Cookies.get('token');
      console.log('Token 1 if');
      if (token) {
        config.headers.Authorize = token;
        console.log('Token 1 else');

      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      // Token might be expired, try to renew
      console.log('Token 2');
      const tokenRenew = getTokenRenew();
      const renewed = tokenRenew ? await tokenRenew() : false;

      if (renewed) {
        console.log('Token 3');
        return axiosClient(error.config);
      } else {
        // If we can't renew, show an error alert
        console.log('Token 4');
        const errAlertOpen = getErrAlertOpen();
        const errAlertText = getErrAlertText();
        if (errAlertOpen && errAlertText) {
          // if (error.config.url.includes('login')) {
            getLogoutHandler();
            errAlertOpen();
            errAlertText('Your session has expired. Please log in again.');
          // }
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
